import {CommonService} from "../../common/commonService";
import {API_MPatient, API_Service} from "../../utils/network/API";

export class FeedbackService {
    constructor() {
        this.commonService = new CommonService(API_Service.ezHealth);
    }

    submitPatientFeedback(param, success, fail) {
        this.commonService.fetchData(API_MPatient.submitPatientFeedback, param, (response) => {
            if (response?.resultCode === 1) {
                success && success()
            } else {
                fail && fail({message: response?.resultDescription})
            }
        }, fail)
    }
}
